export default __webpack_public_path__ + "static/media/Phone.e9d42e75.png";